var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("Loading"),
      _c("div", { staticClass: "d-block d-md-none" }, [_c("Header")], 1),
      _c("div", { staticClass: "d-none d-md-block" }, [_c("HeaderDesktop")], 1),
      _c("div", { staticClass: "content-padding" }, [_c("router-view")], 1),
      _c("Footer"),
      _vm.showVerifyVignetteModal
        ? _c("VerifyVignette", {
            model: {
              value: _vm.showVerifyVignetteModal,
              callback: function ($$v) {
                _vm.showVerifyVignetteModal = $$v
              },
              expression: "showVerifyVignetteModal",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }